import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SpeciesRegistry           from './SpeciesRegistry';
import BreedEcotypeRegistry      from './BreedEcotypeRgistry';
import ProductionPurposeRegistry from './ProductionPurposeRegistry';
import AgeClassRegistry          from './AgeClassRegistry';

const SUBTABS = [
  { key: 'species-registry', label: 'Species Registry',            Component: SpeciesRegistry           },
  { key: 'breed',            label: 'Breed Ecotype Registry',      Component: BreedEcotypeRegistry      },
  { key: 'purpose',          label: 'Production Purpose Registry', Component: ProductionPurposeRegistry },
  { key: 'age',              label: 'Age Class Registry',          Component: AgeClassRegistry          },
];

export default function SpeciesLivestockRegistry() {
  const navigate     = useNavigate();
  const { pathname } = useLocation();
  const sub = pathname.split('/').filter(Boolean)[2] ?? 'species-registry';
  const Active = SUBTABS.find(s => s.key === sub)?.Component ?? SpeciesRegistry;

  return (
    <section>
      <div className="mb-5 flex flex-wrap gap-3">
        {SUBTABS.map((s) => (
          <button
            key={s.key}
            type="button"
            onClick={() => navigate(`/registry-management/species/${s.key}`)}
            className={`rounded-lg border px-4 py-2 text-sm font-medium ${
              sub === s.key
                ? 'border-green-100 bg-green-50 font-semibold text-green-700'
                : 'border-gray-200 bg-white text-gray-700 hover:border-green-500'
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>
      <Active />
    </section>
  );
}
